/** Participant enrollment status - must match valid values in backend (`Dtos/ParticipantEnrollmentStatusDtoTypes.cs`) */
export const ParticipantEnrollmentStatus = {
  Applied: "søkt",
  Enrolled: "påmeldt",
} as const;
